import { useContext } from "react";
import { TurnstileContext } from "@/contexts/TurnstileProvider";

export function useTurnstile() {
  const context = useContext(TurnstileContext);

  if (!context) {
    throw new Error("useTurnstile must be used within a TurnstileProvider");
  }

  return context;
}
